module.exports = __webpack_public_path__ + "static/cn-e2df247ed96bcfc35b260486457a471b.png";